module.exports = __webpack_public_path__ + "static/media/br.d584a724.jpeg";